export default {
  tabs: {
    calendar: 'My Time',
    list: 'Transaction History Status',
    approve: 'Time Approve',
    'approver-calendar': 'Approve Calendar'
  },
  dataState: {
    loading: 'Loading…',
    failed: 'Unable to load data. Please try again.',
    empty: 'No transactions',
    retry: 'Try again'
  },
  title: 'E-Time',
  report: 'REPORT',
  selectedStatuses: '{{count}} statuses selected',
  radio: {
    calendar: 'Calendar',
    list: 'List',
    export: 'Export'
  },
  modal: {
    title: 'Record'
  },
  option: {
    'Request/Edit Time': 'Request/Edit Time',
    'Request OT': 'Request OT',
    'Request Special Allowance': 'Request Special Allowance'
  }
}
